module.exports = __webpack_public_path__ + "static/img/gkpt.48b53583.png";